import './card-category-link.scss'

import { Link } from 'gatsby'
import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getTransWithoutMissingKey } from '@/i18n/config'

const CategoryLink = ({ mainCategory, subCategory, i18n, onClick, type }) => {
  const { t } = useTranslation()
  let mainCatKey = _.get(mainCategory, 'slug', '')
  let subCatKey = _.get(subCategory, 'slug', '')
  let mainCatTitle = getTransWithoutMissingKey(
    `categories.${mainCatKey}`,
    i18n,
    t
  )
  mainCatTitle =
    mainCatTitle === 'NFT Stories' ? 'NFT Deep Dives' : mainCatTitle

  let subCatTitle = getTransWithoutMissingKey(
    `categories.${subCatKey}`,
    i18n,
    t
  )

  return (
    <>
      <Link
        state={{ filter: null }}
        to={
          i18n.language.startsWith('en')
            ? `/${_.get(mainCategory, 'url', '')}`
            : `/${_.get(
                mainCategory,
                'url',
                ''
              )}/${i18n.language.toLowerCase()}`
        }
      >
        <span
          onClick={() => {
            let filterState = {}
            filterState[type] = null
            onClick && onClick(filterState)
          }}
        >
          {mainCatTitle}
        </span>
      </Link>
      {' / '}
      <Link
        state={{ filter: _.get(subCategory, 'description', '') }}
        to={
          i18n.language.startsWith('en')
            ? `/${_.get(mainCategory, 'url', '')}`
            : `/${_.get(
                mainCategory,
                'url',
                ''
              )}/${i18n.language.toLowerCase()}`
        }
      >
        <span>{subCatTitle}</span>
      </Link>
    </>
  )
}

export const CardCategoryLink = ({
  mainCategory,
  subCategory,
  minicard,
  date,
  i18n,
  onClick,
  type,
}) => {
  return (
    <>
      <div className="card-category show-tablet">
        <p>
          <CategoryLink
            mainCategory={mainCategory}
            subCategory={subCategory}
            i18n={i18n}
            onClick={onClick}
            type={type}
          />
          {!minicard && ` - ${date}`}
        </p>
        <p>{minicard && `${date}`}</p>
      </div>
      <div className="card-category show-mobile">
        <p>
          <CategoryLink
            mainCategory={mainCategory}
            subCategory={subCategory}
            i18n={i18n}
          />
        </p>
        <p>{`${date}`}</p>
      </div>
    </>
  )
}
